import * as types from "./actionTypes"

const INITIAL_STATE = {
  contas: [],
  grupos: [],
  loading: false,
  saving: false,
  erros: [],
  impactos: [],
  erro: null,
  salvoEm: null,
}

const PlanoContas = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.BUSCAR_PLANO_CONTAS_CADASTRO:
      return { ...state, loading: true, erro: null, erros: [], impactos: [] }
    case types.BUSCAR_PLANO_CONTAS_CADASTRO_SUCESSO:
      return { ...state, loading: false, contas: action.payload.contas, grupos: action.payload.grupos }
    case types.BUSCAR_PLANO_CONTAS_CADASTRO_FALHA:
      return { ...state, loading: false, contas: [], grupos: [], erro: action.payload }
    case types.SALVAR_PLANO_CONTAS_LOTE:
      return { ...state, saving: true, erro: null, erros: [], impactos: [], salvoEm: null }
    case types.SALVAR_PLANO_CONTAS_LOTE_SUCESSO:
      return { ...state, saving: false, contas: action.payload, salvoEm: Date.now() }
    case types.SALVAR_PLANO_CONTAS_LOTE_IMPACTOS:
      return { ...state, saving: false, impactos: action.payload }
    case types.SALVAR_PLANO_CONTAS_LOTE_ERROS:
      return { ...state, saving: false, erros: action.payload }
    case types.SALVAR_PLANO_CONTAS_LOTE_FALHA:
      return { ...state, saving: false, erro: action.payload }
    case types.LIMPAR_IMPACTOS_PLANO_CONTAS:
      return { ...state, impactos: [] }
    default:
      return state
  }
}

export default PlanoContas
